import CryptoJS from 'crypto-js';

const secretKeyBase64 = import.meta.env.VITE_APP_KEY;
const secretKey = CryptoJS.enc.Base64.parse(secretKeyBase64);
const iv = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_APP_IV); // IV de 16 caractères

function base64UrlDecode(base64Url) {
    let base64 = base64Url
        .replace(/-/g, '+') // Remettre '-' à '+'
        .replace(/_/g, '/'); // Remettre '_' à '/'

    // Ajouter le padding manquant si nécessaire
    while (base64.length % 4 !== 0) {
        base64 += '=';
    }

    return base64;
}

function decryptData(encryptedData) {
    const encryptedBase64 = base64UrlDecode(encryptedData);
    
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, secretKey, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: iv,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
}

export default decryptData;